import { render, staticRenderFns } from "./ModalPendenciaConfirmar.vue?vue&type=template&id=67f0e9c4&scoped=true"
import script from "./ModalPendenciaConfirmar.vue?vue&type=script&lang=ts"
export * from "./ModalPendenciaConfirmar.vue?vue&type=script&lang=ts"
import style0 from "./ModalPendenciaConfirmar.vue?vue&type=style&index=0&id=67f0e9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f0e9c4",
  null
  
)

export default component.exports